import { MatchCenterEvents } from '@news-mono/web-common'
import React, { useContext } from 'react'
import { Skeleton } from '../../content'
import { ScoreBoard } from '../../ScoreBoard/ScoreBoard'
import { OptaAflApiContext } from '../OptaAflApiProvider'
import { AflScoreBoardProps } from './AflScoreBoard.routing'
import { StyledScoreboardSkeletonWrapper } from './AflScoreBoard.styled'
import { AflFixtureData, TabTouchOdds } from './types'

const getAflFixtureDataFromFallbackApi = (
    fallbackData: any,
    tabTouchOdds?: TabTouchOdds,
): AflFixtureData => {
    return {
        date: fallbackData?.utcStartTime || fallbackData?.startTimeUTC,
        match_status: fallbackData?.matchStatus,
        venue: {
            name: fallbackData?.venueName,
            place: '',
        },
        round: fallbackData?.roundNumber,
        period: '',
        periodCompleted: '',
        periodSeconds: '',
        homeTeam: {
            id: fallbackData?.homeSquadId,
            name: fallbackData?.homeSquadName,
            score: {
                score: '-',
                goals: '-',
                behinds: '-',
            },
        },
        awayTeam: {
            id: fallbackData?.awaySquadId,
            name: fallbackData?.awaySquadName,
            score: {
                score: '-',
                goals: '-',
                behinds: '-',
            },
        },
        rawApiData: undefined,
        tabTouchOdds,
    }
}

interface Props extends AflScoreBoardProps {
    onEvent: (event: MatchCenterEvents) => void
}

export const AflScoreBoard = ({
    gameId,
    apiData,
    verticalGutters,
    verticalSpacing,
    sectionHeader,
    onEvent,
}: Props) => {
    const { data, error, loading } = useContext(OptaAflApiContext)

    if (loading) {
        return (
            <StyledScoreboardSkeletonWrapper>
                <Skeleton count={1} dark={false} />
            </StyledScoreboardSkeletonWrapper>
        )
    }
    if (!data) {
        if (!apiData) {
            return null
        }
        const fallbackData = getAflFixtureDataFromFallbackApi(
            apiData?.report?.aflMatchStats?.matchInfo['@attributes'],
            apiData?.tabTouchOdds,
        )
        if (
            fallbackData.match_status === 'scheduled' ||
            fallbackData.match_status === 'prematch'
        ) {
            return (
                <>
                    <ScoreBoard
                        response={{ type: 'afl', data: fallbackData }}
                        verticalGutters={verticalGutters}
                        verticalSpacing={verticalSpacing}
                        sectionHeader={sectionHeader}
                        onEvent={onEvent}
                    />
                </>
            )
        } else {
            return null
        }
    }

    if (!data.tabTouchOdds) {
        data.tabTouchOdds = apiData?.tabTouchOdds
    }

    return (
        <>
            <ScoreBoard
                response={{ type: 'afl', data: data }}
                verticalGutters={verticalGutters}
                verticalSpacing={verticalSpacing}
                sectionHeader={sectionHeader}
                onEvent={onEvent}
            />
        </>
    )
}
